<ng-container *ngIf="company?.id">
    <ng-template #tenantRelation>
        <ng-container *ngIf="showTenantRelations">
            <ng-container *ngIf="showTenantRelationWithLineBreak">
                <br>
            </ng-container>
            <bcm-tenant-relation-colored-label
                    [tenantRelations]="company.activeAndNextTenantRelationAssignments"></bcm-tenant-relation-colored-label>
        </ng-container>
    </ng-template>
    <ng-container *ngIf="prefix">{{ prefix }}</ng-container>
    <ng-container *ngIf="disableLink; else withLink">
        <span [attr.data-test]="dataTest">
            <ng-container *ngIf="company?.fullName; else noName">
                {{ company.fullName }}
                <ng-container *ngTemplateOutlet="tenantRelation"></ng-container>
            </ng-container>
            <ng-template #noName>
                <abbr matTooltip="Organisation kann nicht identifiziert werden!">
                    <em>Kein Name</em>
                </abbr>
            </ng-template>
        </span>
    </ng-container>
    <ng-template #withLink>
        <a (click)="click($event)"
           [attr.data-test]="dataTest"
           [attr.target]="openInNewTab ? '_blank' : null"
           [attr.rel]="openInNewTab ? 'noopener' : null"
           [bcmRouterLink]="routeTab ? ['companies', company.id, routeTab] : ['companies', company.id]">
            {{ company.fullName }}
        </a>
        <ng-container *ngTemplateOutlet="tenantRelation"></ng-container>
    </ng-template>
    <ng-container *ngIf="suffix">{{ suffix }}</ng-container>
</ng-container>
